import script from "./VueModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VueModal.vue?vue&type=script&setup=true&lang=js"

import "./VueModal.vue?vue&type=style&index=0&id=4f0a20d7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0a20d7"]])

export default __exports__